export class ColetorFactory {
  constructor(instance) {
    this.instance = instance;
  }

  listSessoes(filter) {
    return this.instance.get('/v1/coletor/sessoes', {
      params: filter || null,
    });
  }

  getSessao(id) {
    return this.instance.get(`/v1/coletor/sessoes/${id}`);
  }

  removeSessao(id) {
    return this.instance.delete(`/v1/coletor/sessoes/${id}`);
  }

  importSessoes(payload) {
    return this.instance.post('/v1/coletor/import', payload);
  }
}

export default (...params) => new ColetorFactory(...params);
